import { InvalidateQueryFilters, useQuery, useQueryClient } from '@tanstack/react-query'
import { getEventLocationDetails } from 'api/event'
import { deleteLocation, getLocationById, getLocations } from 'api/locations'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { TableConfig } from 'types/TableHeader'

export const useLocationById = (id: string, isEventLocation = false) => {
    const { data, isLoading, error } = useQuery({
        queryKey: [isEventLocation ? 'event-location' : 'location', id],
        queryFn: () => (isEventLocation ? getEventLocationDetails(id) : getLocationById(id)),
        enabled: !!id,
    })

    return { data, isLoading, error }
}

export const useLocationsAdmin = (partnerId?: string) => {
    const [searchTerm, setSearchTerm] = useState('')
    const navigate = useNavigate()
    const queryClient = useQueryClient()
    const linkToForm = '/admin/helyszinek/form'

    const handleSearch = (value: string) => {
        setSearchTerm(value)
        queryClient.invalidateQueries(['locations'] as InvalidateQueryFilters)
    }

    const handleEdit = (data: any) => {
        if (partnerId) {
            navigate(`/admin/helyszinek/form/${data.location_id}?partnerId=${partnerId}`)
        } else {
            navigate(`/admin/helyszinek/form/${data.location_id}`)
        }
    }

    const handleDelete = async (locationId: string) => {
        try {
            await deleteLocation(locationId)
            queryClient.invalidateQueries(['locations'] as InvalidateQueryFilters)
        } catch (error) {
            console.error('Error deleting location:', error)
        }
    }

    const tableConfig: TableConfig = {
        titleRow: {
            title: 'Helyszínek',
            buttonLabel: 'Helyszín felvétele',
            formConfig: {
                dialogProps: {
                    header: 'Helyszín felvétele',
                },
            },
        },
        headers: [
            { field: 'name', title: 'Helyszín sablon', sortable: true },
            { field: 'address', title: 'Cím', sortable: true },
        ],
        idName: 'location_id',
    }

    //ADMIN
    const { data, isLoading, error } = useQuery({
        queryKey: ['locations', searchTerm],
        queryFn: () => getLocations(searchTerm, true, partnerId),
    })

    return {
        data,
        linkToForm,
        isLoading,
        error,
        tableConfig,
        handleEdit,
        handleDelete,
        handleSearch,
    }
}
